<template>
  <MenuComponent>
    <template #navbar>
      <StopListNavBar
        ref="navBar"
        :filter.sync="filter"
        :list="blocked_items"
        :loading="loading"
        :types="types"
        @changeFilter="count = 0"
        @filter="filterList"/>
    </template>
    <template #filter>
      <TooltipedBtn
        class="my-auto mr-3"
        data-qa="btn-export-to-excel"
        :disabled="!filtred_items || !filtred_items.length"
        icon="excel"
        :loading="loading"
        :text="$t('Tenders.DownloadTendersToExcel')"
        :texted="$vuetify.breakpoint.lgAndUp"
        @click="downloadStopListToExcel"/>
      <SearchInput
        class="my-auto"
        debounce
        :search.sync="search"
        width="150px"
        @input="applySearch"/>
    </template>
    <template #items>
      <EmptyBlock
        v-if="!loading && (!groups || !Object.keys(groups).length )"
        :text="$t('StopLists.NoStopped')"/>
      <template v-for="([name, items] ) in Object.entries(groups)">
        <div
          v-if="items.length"
          :key="name + filtred_items.length + items.length + Object.keys(groups).length"
          class="content py-0">
          <div class="stop-title text-start  px-0 h4-headline pt-8 pr-10 pb-2">
            {{ $t(name) }}
          </div>
          <div>
            <StopCard
              v-for="(item, n) in items"
              :key="item.id + '' + n"
              :item="item"
              :last="n == (items.length - 1)"
              :show-organisation="stop_list.length > 1"
              @updateGroups="updateGroups"/>
          </div>
        </div>
      </template>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_load"
        class="mt-3"
        :loading="loading "
        :pixels_when_update="150"/>
    </template>
  </MenuComponent>
</template>

<script>
import StopCard from 'components/stop lists/StopCard.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import StopListNavBar from 'components/stop lists/StopListsNavBar.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

import { mapGetters } from 'vuex'
import moment from 'moment'
import { stopListsMixin } from 'mixins'

import axios from 'axios'
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

export default {
  name: 'stopLists',
  mixins: [ stopListsMixin],
  data() {
    return {
      loading: false,
      filter: {},
      groups: [],
      count: 0,
      search: ''
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER',
      changeOrganisation: 'changeOrganisation',
    }),

    stop_list() {
      return this.$store.getters.getStopList
    },
    types() {
      return [
        {
          name: 'StopLists.AllAddedCompanies',
          type: 'all'
        },
        {
          name: 'StopLists.Blocked',
          type: 'locked',
          class: 'pl-7',
          filter: this.filterLocked
        },
        {
          name: 'StopLists.LockedPermanently',
          type: 'permanently',
          class: 'pl-7',
          filter: this.lockedPermanently
        },
        {
          name: 'StopLists.BlockedByMe',
          type: 'mine',
          class: 'pl-7',
          filter: this.lockedByMe
        },
        {
          name: 'StopLists.Unlocked',
          type: 'unlocked',
          class: 'pl-7',
          filter: item => !this.filterLocked(item)
        },
      ]
    },
    blocked_items() {
      let items = this.stop_list?.reduce((total, item) => {
        let items = item.stopListMembers.map(el => {
          let obj = { ...el, ...el.totalStopListBlockRow, blocked_for: item.organizationName }
          delete obj.totalStopListBlockRow
          this.setStatus(obj)
          return obj
        })
        total.push(...items)
        return total
      }, [] )

      items.sort((first, second) => {
        if (this.willUnlockThisMonth(first) ) {
          return -1
        }
        if ( !this.filterLocked(first) && this.filterLocked(second)) {
          return 1
        }
        if ( this.filterLocked(first) && !this.filterLocked(second)) {
          return -1
        }

        if ( this.filterLocked(first) && first.dateTo && this.filterLocked(second) && !second.dateTo ) {
          return 1
        }
      } )
      return items
    },
    filtred_items() {
      let  items = this.blocked_items?.slice(0)
      if (this.filter?.filter || this.search) {
        items = items?.filter( item => {
          let result = true
          if ( this.filter?.filter ) {
            result = this.filter?.filter(item)
          }
          if (this.search) {
            let usreou = item.usreou,
              name = item.organizationName,
              lower_name = name?.toLowerCase().trim(),
              lower_usreou = usreou?.toLowerCase().trim(),
              lower_search = this.search?.toLowerCase().trim(),
              searched = (name
                && lower_name.includes(lower_search) )
                || (usreou && lower_usreou.includes(lower_search))

            result = result && searched
          }
          return result
        })
      }
      return items
    },
    per_page() {
      let elm = this.$el
      return Math.floor((elm?.clientHeight || 0) /  150) || 0
    },
    can_load() {
      return this.count != this.filtred_items.length
    }
  },
  methods: {
    async downloadStopListToExcel() {
      this.loading = true
      const url = `${window.config.GrapgQlUrl}/files/stopList/report`
      const headers = await files_api.getHeaders()
      headers['Content-Type'] = 'application/json'

      const orgIds = this.filtred_items.map(i => i.organizationId).filter(i => i)
      await axios.post(url,
        { organizationIds: orgIds },
        {
          headers,
          responseType: 'blob'
        }
      ).then((response) => {
        var { extension } = require('mime-types')
        let url = URL.createObjectURL(response.data)
        let a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', `${this.$t('Menu.StopLists')}.${extension(response.data.type)}`)
        a.click()
      }).finally(() => {
        this.loading = false
      })
    },
    async loadData(condition) {
      this.loading = true
      this.$store.dispatch('getStopList', condition)
        .finally( () => {
          this.loading = false
        })
    },
    filterLocked( item ) {
      return item.status == 'E'
    },
    lockedPermanently( item ) {
      return this.filterLocked(item) && !item.dateTo
    },
    lockedByMe( item ) {
      return this.filterLocked(item) && item.addIsMe
    },
    willUnlockThisMonth(item) {
      let dateTo = item.dateTo, less = moment(dateTo) < moment().add(1, 'months'),
        more = moment(dateTo) > moment()
      return this.filterLocked(item) && less && more
    },
    filterList( filter ) {
      this.filter = filter
      this.updateFiltredGroups()
    },
    setGroups() {
      let groups = {}
      groups['StopLists.WillUnlockedThisMonth'] = []
      this.types.map(el => {
        if (el.filter && el.type != 'mine') {
          groups[el.name] = []
        }
      })
      this.groups = groups
    },
    setGroupsItems() {
      let items = this.filtred_items.slice(0)
      items = items.slice(this.count, this.count + this.per_page)
      let groups = this.groups
      items.forEach( item => {

        if ( this.lockedPermanently(item)) {
          return groups['StopLists.LockedPermanently'].push(item)
        }
        if ( this.willUnlockThisMonth(item) ) {
          return groups['StopLists.WillUnlockedThisMonth'].push(item)
        }
        if ( this.filterLocked(item) ) {
          return groups['StopLists.Blocked'].push(item)
        }
        return groups['StopLists.Unlocked'].push(item)
      })
    },
    infinityLoad( ) {
      if (this.count < this.filtred_items.length) {
        this.count = Math.min(this.filtred_items.length, this.count + this.per_page)
        this.setGroupsItems()
      }
    },
    applySearch(search) {
      this.search = search
      this.updateFiltredGroups()
    },
    updateFiltredGroups() {
      this.$refs.infinity_updater?.updateScrollCount(true)
      this.count = 0
      this.updateGroups(this.groups)
    },
    updateGroups(groups) {
      if ( !this.filtred_items?.length ) {
        return
      }
      this.setGroups()
      this.setGroupsItems(groups)
    }
  },
  watch: {
    changeOrganisation( val ) {
      if ( !val ) {
        this.loadData(true)
      } else {
        this.count = 0
        this.groups = {}
      }
    },
    filtred_items() {
      this.$nextTick(this.updateFiltredGroups)
    },
  },
  components: {
    StopCard,
    EmptyBlock,
    SearchInput,
    MenuComponent,
    StopListNavBar,
    InfinityUpdater,
    TooltipedBtn
  }
}
</script>
